import React from "react";
import PropTypes from "prop-types";
import {Button, ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import IntegrationConfigurationService from "./IntegrationConfigurationService";
import Notify from "../../services/Notify";
import Box from "../../component/Box/Box";
import Loading from "../../component/Loading/Loading";
import CheckpointSelector from "../../checkpoint/CheckpointSelector";

class IntegrationConfigurationForm extends React.Component {

  service = new IntegrationConfigurationService();

  constructor(props) {
    super(props);
    this.state = {};
    this.configuration = {};
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      this.setState({loading: true, typeLoading: true});

      this.service.findById(id).then(
          data => this.setState(
              {
                loading: false,
                entity: data
              }),
          error => {
            const state = {loading: false};
            if (error.response.status === 404) {
              state.message = 'Entidade não encontrada!';
            } else {
              state.message = 'Erro inesperado!';
              Notify.error('Falha o buscar entidade!', error)
            }
            this.setState(state);
          }
      );

      this.service.findTypes().then(
          (data) => {
            this.setState({types: data.content, typeLoading: false})
          },
          (error) => {
            Notify.error('Falha ao buscar tipos!', error);
            this.setState({typeLoading: false});
          }
      )

    }
  }

  submitForm() {
    const existingEntity = this.state.entity.id;
    const entityVersion = this.state.entity.version;
    const configurations = [];
    for (let id in this.configuration) {
      let value = this.configuration[id];

      if (value instanceof Element) {
        value = value.value;
      }

      configurations.push({configurationType: id, value})
    }

    const entity = {
      id: existingEntity,
      configurations,
      version: entityVersion
    };

    this.service.save(entity).then(
        () => {
          this.props.history.goBack();
          Notify.success('Entidade salva');
        },
        (error) => Notify.error('Falha ao salvar entidade:', error));
  }

  findForm({id, name}, configurations, index) {
    let input;
    const defaultValue = configurations[id];
    switch (id) {
      case 'CONSUMED_INTEGRATION_CHECKPOINT_ID':
      case 'UNBLOCKED_INTEGRATION_CHECKPOINT_ID':
      case 'BLOCKED_INTEGRATION_CHECKPOINT_ID':
        input = <CheckpointSelector setValue={value => this.configuration[id] = value} defaultValue={defaultValue}/>;
        break;
      case 'COMMISSIONER_INTEGRATION_CHECKPOINT_ID':
        input = <CheckpointSelector commissioner setValue={value => this.configuration[id] = value} defaultValue={defaultValue}/>;
        break;
      default:
        input = <FormControl
            type="text"
            value={this.state.value}
            inputRef={ref => {
              this.configuration[id] = ref
            }}
            defaultValue={defaultValue}
            placeholder="Enter text"
        />;
    }

    return (
        <FormGroup key={index}>
          <ControlLabel>{name}</ControlLabel>
          {input}
        </FormGroup>)
  }

  render() {
    const {loading, entity = {}, message, types = [], typeLoading = true} = this.state;
    if (loading || typeLoading) {
      return <Loading/>
    }
    if (message) {
      return <h2>{message}</h2>
    }

    const configurations = {};
    entity.configurations.forEach(item => configurations[item.configurationType] = item.value);

    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>


            {types.map((configuration, index) => this.findForm(configuration, configurations, index))}

            <div className="row" style={{marginRight: 0}}>
              <div className="pull-right">
                <Button className="btn btn-default"
                        onClick={() => this.props.history.goBack()}>Cancelar</Button>
                <Button type="submit" bsStyle="success">Salvar</Button>
              </div>
            </div>
          </form>
        </Box>);
  }
}

IntegrationConfigurationForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default IntegrationConfigurationForm;



// WEBPACK FOOTER //
// ./src/integration/configuration/IntegrationConfigurationForm.js